// skipcq: JS-W1028
import {
  formatEventLocalDateOnlyLabel,
  formatEventLocalTimeRangeLabel,
} from '../../domain/eventTimezones';

/**
 * @param {Record<string, unknown> | null | undefined} mergedEvent
 * @returns {object | null}
 */
export function buildEventDetailViewModel(mergedEvent) {
  if (!mergedEvent) {
    return null;
  }
  const dateLine = formatEventLocalDateOnlyLabel(
    mergedEvent.eventLocalDate,
    mergedEvent.eventTimezone,
  );
  const timeLine = formatEventLocalTimeRangeLabel(
    mergedEvent.eventLocalDate,
    mergedEvent.eventTimezone,
    mergedEvent.eventStartTime,
    mergedEvent.eventEndTime,
  );
  const cityState = String(mergedEvent.cityState ?? '').trim();
  const locationLine = String(mergedEvent.location ?? '').trim();
  const legacyVenueName = String(mergedEvent.venueName ?? '').trim();
  const venueDisplay = locationLine || legacyVenueName;
  const linkTrimmed = String(mergedEvent.link ?? '').trim();
  const linkLabel =
    String(mergedEvent.linkText ?? '').trim() ||
    (linkTrimmed ? 'Click here for details & to buy tickets' : '');
  const description = String(mergedEvent.description ?? '').trim();
  const hostDisplay = String(mergedEvent.host ?? '').trim();
  const eventName = String(mergedEvent.name ?? '').trim();

  return {
    dateLine,
    timeLine,
    venueDisplay,
    cityState,
    linkTrimmed,
    linkLabel,
    description,
    hostDisplay,
    eventName,
  };
}
